import component_add_list from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/AddList/index.vue'
import component_artboard from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Artboard/index.vue'
import component_assistant from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Assistant/index.vue'
import component_block_add_list from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/BlockAddList/index.vue'
import component_clipboard from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Clipboard/index.vue'
import component_command_palette from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/CommandPalette/index.vue'
import component_comments from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Comments/index.vue'
import component_conversions from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Conversions/index.vue'
import component_debug from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Debug/index.vue'
import component_delete from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Delete/index.vue'
import component_diff from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Diff/index.vue'
import component_dragging_overlay from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/DraggingOverlay/index.vue'
import component_duplicate from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Duplicate/index.vue'
import component_edit from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Edit/index.vue'
import component_edit_form from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/EditForm/index.vue'
import component_editable_field from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/EditableField/index.vue'
import component_editable_mask from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/EditableMask/index.vue'
import component_entity_title from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/EntityTitle/index.vue'
import component_exit from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Exit/index.vue'
import component_field_areas from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/FieldAreas/index.vue'
import component_fragments from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Fragments/index.vue'
import component_grid from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Grid/index.vue'
import component_help from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Help/index.vue'
import component_history from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/History/index.vue'
import component_import_existing from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/ImportExisting/index.vue'
import component_library from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Library/index.vue'
import component_media_library from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/MediaLibrary/index.vue'
import component_multi_select from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/MultiSelect/index.vue'
import component_options from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Options/index.vue'
import component_ownership from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Ownership/index.vue'
import component_preview from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Preview/index.vue'
import component_preview_grant from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/PreviewGrant/index.vue'
import component_proxy_view from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/ProxyView/index.vue'
import component_publish from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Publish/index.vue'
import component_responsive_preview from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/ResponsivePreview/index.vue'
import component_revert from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Revert/index.vue'
import component_search from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Search/index.vue'
import component_selection from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Selection/index.vue'
import component_settings from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Settings/index.vue'
import component_structure from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Structure/index.vue'
import component_touch_action_bar from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/TouchActionBar/index.vue'
import component_tour from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Tour/index.vue'
import component_transform from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Transform/index.vue'
import component_translations from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Translations/index.vue'
import component_validations from '/var/www/html/frontend/node_modules/@blokkli/editor/dist/runtime/components/Edit/Features/Validations/index.vue'

export const availableFeaturesAtBuild = ["add-list","artboard","assistant","block-add-list","clipboard","command-palette","comments","conversions","debug","delete","diff","dragging-overlay","duplicate","edit","edit-form","editable-field","editable-mask","entity-title","exit","field-areas","fragments","grid","help","history","import-existing","library","media-library","multi-select","options","ownership","preview","preview-grant","proxy_view","publish","responsive-preview","revert","search","selection","settings","structure","touch-action-bar","tour","transform","translations","validations"]


export const featureComponents = {
  'add-list': component_add_list,
  'artboard': component_artboard,
  'assistant': component_assistant,
  'block-add-list': component_block_add_list,
  'clipboard': component_clipboard,
  'command-palette': component_command_palette,
  'comments': component_comments,
  'conversions': component_conversions,
  'debug': component_debug,
  'delete': component_delete,
  'diff': component_diff,
  'dragging-overlay': component_dragging_overlay,
  'duplicate': component_duplicate,
  'edit': component_edit,
  'edit-form': component_edit_form,
  'editable-field': component_editable_field,
  'editable-mask': component_editable_mask,
  'entity-title': component_entity_title,
  'exit': component_exit,
  'field-areas': component_field_areas,
  'fragments': component_fragments,
  'grid': component_grid,
  'help': component_help,
  'history': component_history,
  'import-existing': component_import_existing,
  'library': component_library,
  'media-library': component_media_library,
  'multi-select': component_multi_select,
  'options': component_options,
  'ownership': component_ownership,
  'preview': component_preview,
  'preview-grant': component_preview_grant,
  'proxy_view': component_proxy_view,
  'publish': component_publish,
  'responsive-preview': component_responsive_preview,
  'revert': component_revert,
  'search': component_search,
  'selection': component_selection,
  'settings': component_settings,
  'structure': component_structure,
  'touch-action-bar': component_touch_action_bar,
  'tour': component_tour,
  'transform': component_transform,
  'translations': component_translations,
  'validations': component_validations
}


const feature_validations = ({
    id: "validations",
    icon: "check",
    label: "Validations",
    description: "Provides a sidebar pane to render validations."
});

const feature_translations = ({
    id: "translations",
    label: "Translations",
    icon: "translate",
    requiredAdapterMethods: ["changeLanguage"],
    description: "Adds support for block translations."
});

const feature_transform = ({
    id: "transform",
    icon: "script",
    label: "Transform",
    requiredAdapterMethods: ["getTransformPlugins", "applyTransformPlugin"],
    description: "Provides integration for block transform plugins.",
    screenshot: "feature-transform.jpg"
});

const feature_tour = ({
    id: "tour",
    label: "Tour",
    icon: "tutor",
    description: "Provides a tour overlay to get to know the editor."
});

const feature_touch_action_bar = ({
    id: "touch-action-bar",
    label: "Touch Action Bar",
    description: "Renders a button on touch devices to cancel touch actions.",
    icon: "button-pointer"
});

const feature_structure = ({
    id: "structure",
    icon: "tree",
    label: "Structure",
    description: "Provides a sidebar button to render a structured list of all blocks on the current page."
});

const feature_settings = ({
    id: "settings",
    label: "Settings",
    icon: "cog",
    description: "Provides a menu button to display a settings dialog.",
    settings: {
        useAnimations: {
            type: "checkbox",
            default: true,
            label: "Use animations",
            description: "Animates UI elements like dialogs or drawers or interactions like drag and drop or scroll changes.",
            group: "advanced"
        },
        lowPerformanceMode: {
            type: "checkbox",
            default: false,
            label: "Enable low performance mode",
            description: "Reduces the animations and interactivity to a minimum for devices with low performance.",
            group: "advanced"
        },
        resetAllSettings: {
            type: "method",
            label: "Reset all settings",
            method: (app) => {
                app.storage.clearAll();
            },
            group: "advanced"
        }
    }
});

const feature_selection = ({
    id: "selection",
    icon: "selection",
    label: "Selection",
    description: "Renders an overlay that highlights the selected blocks."
});

const feature_search = ({
    id: "search",
    icon: "search",
    label: "Search",
    description: "Provides an overlay with shortcut to search for blocks on the current page or existing content to add as blocks."
});

const feature_revert = ({
    id: "revert",
    icon: "revert",
    label: "Revert",
    requiredAdapterMethods: ["revertAllChanges"],
    description: "Provides a menu button to revert all changes done on the current entity."
});

const feature_responsive_preview = ({
    id: "responsive-preview",
    icon: "cellphone",
    label: "Responsive Preview",
    viewports: ["desktop"],
    description: "Provides a responsive preview of the current edit state in an iframe."
});

const feature_publish = ({
    id: "publish",
    icon: "publish",
    label: "Publish",
    requiredAdapterMethods: ["publish"],
    description: "Provides a menu button to publish the changes of the current entity.",
    settings: {
        closeAfterPublish: {
            type: "checkbox",
            label: "Close editor after publishing",
            description: "Immediately closes the editor after successfully publishing or saving.",
            default: true,
            group: "behavior"
        }
    }
});

const feature_proxy_view = ({
    id: "proxy_view",
    label: "Proxy View",
    icon: "tree",
    description: "Displays the blocks as a structure in the preview.",
    viewports: ["desktop"]
});

const feature_preview_grant = ({
    id: "preview-grant",
    label: "Preview Grant",
    icon: "qrcode",
    description: "Provides a button to open a dialog with a QR code to preview the page on a smartphone.",
    requiredAdapterMethods: ["getPreviewGrantUrl"],
    viewports: ["desktop"]
});

const feature_preview = ({
    id: "preview",
    label: "Preview",
    icon: "preview",
    description: "Provides a button to open a preview in a new window."
});

const feature_ownership = ({
    id: "ownership",
    icon: "user",
    label: "Ownership",
    requiredAdapterMethods: ["takeOwnership"],
    description: "Renders a large button to take ownership of the current edit state."
});

const feature_options = ({
    id: "options",
    label: "Options",
    icon: "palette",
    description: "Renders the options form for one or more blocks.",
    requiredAdapterMethods: ["updateOptions"]
});

const feature_multi_select = ({
    id: "multi-select",
    label: "Multiselect",
    icon: "multi-select",
    description: "Implements support for selecting multiple blocks using a select rectangle.",
    viewports: ["desktop"]
});

const feature_media_library = ({
    id: "media-library",
    icon: "image",
    label: "Media Library",
    description: "Implements a media library to easily drag and drop media like images or videos.",
    requiredAdapterMethods: ["mediaLibraryGetResults", "mediaLibraryAddBlock"]
});

const feature_library = ({
    id: "library",
    icon: "reusable",
    label: "Library",
    description: "Implements support for a block library to manage reusable blocks.",
    requiredAdapterMethods: ["makeBlockReusable", "detachReusableBlock"],
    dependencies: ["add-list"]
});

const feature_import_existing = ({
    id: "import-existing",
    label: "Import existing content",
    icon: "import",
    requiredAdapterMethods: ["getImportItems", "importFromExisting"],
    description: "Implements a menu action that renders a dialog to import blocks from another entity.",
    settings: {
        showDialogWhenEmpty: {
            type: "checkbox",
            default: true,
            label: "Show import dialog at start",
            description: "Displays the import dialog when starting bl\xF6kkli if the page is empty.",
            group: "behavior"
        }
    }
});

const feature_history = ({
    id: "history",
    icon: "history",
    label: "History",
    requiredAdapterMethods: ["setHistoryIndex"],
    description: "Implements support for history features (undo, redo, list of mutations).",
    settings: {
        useMouseButtons: {
            type: "checkbox",
            label: "Use mouse buttons for undo/redo",
            description: "When enabled you can use the backwards/forwards buttons on your mouse to undo and redo.",
            default: true,
            group: "behavior",
            viewports: ["desktop"]
        }
    }
});

const feature_help = ({
    id: "help",
    icon: "help",
    label: "Help",
    description: "Provides a sidebar pane with helpful information on how to use blokkli.",
    viewports: ["desktop"]
});

const feature_grid = ({
    id: "grid",
    label: "Grid",
    icon: "grid",
    requiredAdapterMethods: ["getGridMarkup"],
    description: "Provides a view option to render a grid.",
    viewports: ["desktop"]
});

const feature_fragments = ({
    id: "fragments",
    icon: "fragment",
    label: "Fragments",
    description: "Provides way to add content fragments defined by the frontend.",
    requiredAdapterMethods: ["fragmentsAddBlock"],
    dependencies: ["add-list"]
});

const feature_field_areas = ({
    id: "field-areas",
    label: "Field Areas",
    icon: "area",
    description: "Provides a view option to render the field areas with labels.",
    viewports: ["desktop"]
});

const feature_exit = ({
    id: "exit",
    label: "Exit",
    icon: "exit",
    description: "Provides a menu button to exit the editor without saving."
});

const feature_entity_title = ({
    id: "entity-title",
    icon: "title",
    label: "Entity Title",
    description: "Renders the title and status of the page entity."
});

const feature_editable_mask = ({
    id: "editable-mask",
    icon: "texturebox",
    label: "Editable Mask",
    description: "Provides a view option to hide non-editable parts of the page.",
    viewports: ["desktop"]
});

const feature_editable_field = ({
    id: "editable-field",
    icon: "textbox",
    label: "Editable Field",
    requiredAdapterMethods: ["updateFieldValue", "getEditableFieldConfig"],
    description: "Implements a form overlay to edit a single field of a block."
});

const feature_edit_form = ({
    id: "edit-form",
    icon: "form",
    label: "Edit Form",
    description: "Listens to edit events and renders an iframe containing the edit form.",
    requiredAdapterMethods: ["formFrameBuilder"]
});

const feature_edit = ({
    id: "edit",
    icon: "edit",
    label: "Edit",
    description: "Provides an action to edit a block.",
    requiredAdapterMethods: ["formFrameBuilder"]
});

const feature_duplicate = ({
    id: "duplicate",
    icon: "duplicate",
    label: "Duplicate",
    requiredAdapterMethods: ["duplicateBlocks"],
    description: "Provides an action to duplicate one or more blocks in place."
});

const feature_dragging_overlay = ({
    icon: "drag",
    id: "dragging-overlay",
    label: "Dragging Overlay",
    description: "Renders an overlay when dragging or placing a block.",
    screenshot: "feature-dragging-overlay.jpg"
});

const feature_diff = ({
    id: "diff",
    label: "Diff",
    icon: "diff",
    description: "Displays a diff of all changes in the edit state.",
    requiredAdapterMethods: ["loadStateAtIndex"],
    beta: true
});

const feature_delete = ({
    id: "delete",
    icon: "delete",
    label: "Delete",
    requiredAdapterMethods: ["deleteBlocks"],
    description: "Provides an action to delete one or more blocks."
});

const feature_debug = ({
    id: "debug",
    label: "Debug",
    icon: "bug",
    description: "Provides debugging functionality."
});

const feature_conversions = ({
    id: "conversions",
    label: "Conversions",
    icon: "convert",
    requiredAdapterMethods: ["getConversions", "convertBlocks"],
    description: "Provides block actions to convert one or more blocks to a different bundle."
});

const feature_comments = ({
    id: "comments",
    icon: "comment",
    label: "Comments",
    requiredAdapterMethods: ["loadComments", "addComment"],
    description: "Provides comment functionality for blocks.",
    screenshot: "feature-comments.jpg"
});

const feature_command_palette = ({
    id: "command-palette",
    icon: "command",
    label: "Command Palette",
    description: "Provides a command palette with search to access most UI features with a keyboard.",
    viewports: ["desktop"]
});

const feature_clipboard = ({
    id: "clipboard",
    label: "Clipboard",
    icon: "clipboard",
    description: "Provides clipboard integration to copy/paste existing blocks or paste supported clipboard content like text or images.",
    settings: {
        openSidebarOnPaste: {
            type: "checkbox",
            default: true,
            label: "Open sidebar when pasting",
            description: "Automatically opens the sidebar when pasting content from the clipboard.",
            group: "behavior"
        }
    },
    screenshot: "feature-clipboard.jpg"
});

const feature_block_add_list = ({
    id: "block-add-list",
    label: "Block Add List",
    icon: "plus",
    description: "Renders a list of block bundles that can be added to the current page.",
    dependencies: ["add-list"],
    screnshot: "feature-block-add-list.jpg",
    settings: {
        hideDisabledBlocks: {
            type: "checkbox",
            label: "Hide blocks that can't be added",
            description: `Hides blocks from the "Add List" if they can't be added to anywhere.`,
            group: "appearance",
            default: false
        }
    }
});

const feature_assistant = ({
    id: "assistant",
    icon: "robot",
    label: "Assistant",
    description: "Provides a dynamic add block action to add one or more blocks generated by an AI assistant.",
    requiredAdapterMethods: [
        "assistantGetResults",
        "assistantAddBlockFromResult"
    ],
    screenshot: "feature-assistant.jpg",
    dependencies: ["add-list"]
});

const feature_artboard = ({
    id: "artboard",
    label: "Artboard",
    icon: "artboard",
    description: "Wraps the entire page in an artboard that can be zoomed and moved using the mouse.",
    settings: {
        persist: {
            type: "checkbox",
            default: true,
            label: "Persist position and zoom",
            description: "Stores and restores the last position and zoom factor of the artboard.",
            group: "artboard",
            viewports: ["desktop"]
        },
        momentum: {
            type: "checkbox",
            default: true,
            label: "Use smooth scrolling",
            description: "Applies smooth animations when scrolling or zooming the artboard.",
            group: "artboard",
            viewports: ["desktop"]
        },
        scrollSpeed: {
            type: "slider",
            default: 1,
            label: "Artboard scroll speed",
            group: "artboard",
            viewports: ["desktop"],
            min: 0.5,
            max: 1.5,
            step: 0.05
        }
    },
    screenshot: "feature-artboard.jpg"
});

const feature_add_list = ({
    id: "add-list",
    icon: "plus",
    label: "Add List",
    description: "Provides the container to render a list of blocks to add or add actions.",
    settings: {
        orientation: {
            type: "radios",
            label: "Add List",
            default: "vertical",
            group: "appearance",
            viewports: ["desktop"],
            options: {
                vertical: {
                    label: "Vertical",
                    icon: "ui-list-vertical"
                },
                horizontal: {
                    label: "Horizontal",
                    icon: "ui-list-horizontal"
                },
                sidebar: {
                    label: "Sidebar",
                    icon: "ui-list-sidebar"
                }
            }
        }
    },
    screenshot: "feature-add-list.jpg"
});

export const featureDefinitions = [
  feature_validations,
  feature_translations,
  feature_transform,
  feature_tour,
  feature_touch_action_bar,
  feature_structure,
  feature_settings,
  feature_selection,
  feature_search,
  feature_revert,
  feature_responsive_preview,
  feature_publish,
  feature_proxy_view,
  feature_preview_grant,
  feature_preview,
  feature_ownership,
  feature_options,
  feature_multi_select,
  feature_media_library,
  feature_library,
  feature_import_existing,
  feature_history,
  feature_help,
  feature_grid,
  feature_fragments,
  feature_field_areas,
  feature_exit,
  feature_entity_title,
  feature_editable_mask,
  feature_editable_field,
  feature_edit_form,
  feature_edit,
  feature_duplicate,
  feature_dragging_overlay,
  feature_diff,
  feature_delete,
  feature_debug,
  feature_conversions,
  feature_comments,
  feature_command_palette,
  feature_clipboard,
  feature_block_add_list,
  feature_assistant,
  feature_artboard,
  feature_add_list
]